import { render, staticRenderFns } from "./EN_Footer.vue?vue&type=template&id=0787e338&"
import script from "./EN_Footer.vue?vue&type=script&lang=js&"
export * from "./EN_Footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports